// Try to use vanilla JavaScript wherever feasible ❤️
require("jquery");
global.$ = global.jQuery = global.jquery = jQuery;
window.$ = window.jQuery = window.jquery = jQuery;

// pagespeed fix for event listeners without passive flag
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};
// end pagespeed fix for event listeners without passive flag

import {onDOMLoaded} from "./util/misc.js";
import 'lightgallery.js';
import 'lg-thumbnail.js';
import Headroom from 'headroom.js';
import "ion-rangeslider";
import "owl.carousel";
import LazyLoad from "vanilla-lazyload";
import 'jquery-countdown';
import 'bootstrap-select';

// Required for Bootstrap to actually function
import "bootstrap/dist/js/bootstrap.bundle";

// Import all components
import SimpleComponentRegistery from "./qlib/SimpleComponentRegistery.js";
import * as components from "./components";

// Register all overlays
components.Overlay.createNew(".menu-label");
components.Overlay.createNew(".filter-label");

function initCollapseValidation(labels) {
  let input, target;

  for (const label of labels) {
    input = $('#'+$(label).attr('for'));
    target = $(label).data('target');

    $(target).collapse(input.prop('checked') ? 'show' : 'hide');
  }
}

onDOMLoaded(() => {
  $('.js-select').selectpicker({
    style: '',
    styleBase: 'custom-select',
    width: '100%',
    deselectAllText: 'Deselecteer alles',
    noneSelectedText: 'Niets geselecteerd',
    noneResultsText: 'Er kwamen geen resultaten overeen met {0}',
    selectAllText: 'Selecteer alles'
  });

  initCollapseValidation($('label[data-toggle="collapse"]'));

  let footerBar = $('.footer-bar');

  window.onscroll = function() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      footerBar.addClass('footer-bar--at-bottom');
    } else {
      footerBar.removeClass('footer-bar--at-bottom');
    }
  };
  // $('.clamp + label').css('pointer-events', 'none');
  let clampLabel = $('.clamp + label');
  let clampToggler = $('.clamp-check');
  let clampWrapper = $('.clamp-wrapper');

  $('.clamp + label').click(function(e) {
    e.preventDefault();

    clampToggler.trigger('click');

    if (!clampToggler.attr('checked')) {
      clampLabel.removeClass('position-absolute');
    } else {
      clampLabel.addClass('position-absolute');
    }
  });

  $('.clamp').click(function() {
    $(this).closest(clampWrapper).find(clampToggler).trigger('click');
  });

  // Javascript to enable link to tab
  var url = document.location.toString();

  // Page load
  if (url.match('#')) {

      let hash = url.split('#')[1];
      hash = hash.split('-noscroll')[0]; // Split on -noscroll so we can stil function

      // Show tab. Always use top position
      // $('.nav-tabs a[href="#' + hash + '"]').tab('show');
      // window.scrollTo(0, 0);

      // Set form inputs who want to remember the hash used
      $('.js-urlhash-input').val(hash);

  }

  // Change url hash when clicking tab and do not scroll
  $('.nav-tabs a').on('shown.bs.tab', function (e) {
      // let x = $(window).scrollLeft();
      // let y = $(window).scrollTop();
      // window.location.hash = e.target.hash;
      // window.scrollTo(x, y);
      // Set form inputs who want to remember the hash used
      $('.js-urlhash-input').val(e.target.hash);
  })

  $('.js-scrollto').on('click', function(e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 500, 'linear');
  });

  $('.js-modal-refresh-close').on('hidden.bs.modal', function (event) {
    document.location.reload();
  });

  $('#shareModal').on('show.bs.modal', function (event) {
    let button = $(event.relatedTarget); // Button that triggered the modal
    let shareUrl = button.data('share-url'); // Extract info from data-* attributes

    // Update the modal's content
    let modal = $(this).find('.modal-body'),
        facebook = modal.find('.js-facebook'),
        twitter = modal.find('.js-twitter'),
        linkedin = modal.find('.js-linkedin'),
        whatsapp = modal.find('.js-whatsapp'),
        emailshare = modal.find('.js-emailshare');
        // wechat = modal.find('.js-wechat');

    facebook.attr('href', `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`);
    twitter.attr('href', `https://twitter.com/intent/tweet?url=${shareUrl}`);
    linkedin.attr('href', `http://www.linkedin.com/shareArticle?url=${shareUrl}`);
    whatsapp.attr('href', `https://wa.me/?text=Is dit iets voor jou%3F ${shareUrl}`);
    emailshare.attr('href', `mailto:?body=Is dit iets voor jou? ${shareUrl}&subject=Is dit iets voor jou%3F`);
    // wechat.attr('href', `weixin://dl/chat`);
  });

  $('#brochureModal').on('show.bs.modal', function (event) {
    let button = $(event.relatedTarget); // Button that triggered the modal
    let pandId = button.data('pandid'); // Extract info from data-* attributes
    let pandUrl = button.data('pandurl');

    // Update the modal's content
    let modal = $(this).find('.modal-body');
    let form = modal.find('form[data-component="form"]');

    if (pandId) {
        let input = modal.find('input[name="pand_id"]');
        input.val(pandId);
    }

    if (pandUrl) {
        form.attr('action', pandUrl);
    }

    if (typeof button.data('alert-no-replace-form') !== 'undefined') {
        form.attr('data-alert-no-replace-form', 1);
    }

  });

  // Initialize components
  SimpleComponentRegistery.queryDocument();

  // Indicate we have javascript support
  document.body.classList.remove("no-js");

  // Toggle header search form
  $(".js-search-btn").click( function() {
    $(".js-header-search").slideToggle(200);
  });
  $("#search-close").click( function() {
    $(".js-header-search").slideUp(200);
  });

  $(".js-search-dropdown-toggle").bind("blur", function() {
    setTimeout(
      function()
      {
        $(".js-search-dropdown").slideUp("fast");
      }, 1000 // Little delay so click actually works.. (quickfix bug)
    );
  });
  $(".js-search-dropdown-toggle").bind("focus", function() {
    setTimeout(
      function()
      {
        $(".js-search-dropdown").slideDown("fast");
      }, 1000 // Little delay so click actually works.. (quickfix bug)
    );
  });

  $(".card .fullscreen").show();



  let slidertehuur = $("#slidertehuur");
  let slidertekoop = $("#slidertekoop");
  let checktehuur = $(".js-checktehuur");
  let checktekoop = $(".js-checktekoop");

  $(".js-range-slider").ionRangeSlider({
    skin: "round",
    prettify_separator: ".",
    force_edges: true,
    onChange: function(scope) {
      scope.input.get(0).dispatchEvent(new Event('change'));

      let el = scope.input;
      let resetterSelector = el.data('resetter');
      if (!resetterSelector || !$(resetterSelector)) {
        return;
      }

      let resetterEl = $(resetterSelector);

      if (scope.from == 0) {
        resetterEl.prop('checked', true);
        resetterEl.trigger('change');
        // validateKoopHuur();
      } else {
        resetterEl.prop('checked', false);
      }

      // dummy.trigger('change');
    }
  });

  // Resetter checkbox.Unchecked forces value of 0. Checked forces default values
  $(".js-range-slider").each(function() {
    let el = $(this);
    let resetterSelector = el.data('resetter');
    if (!resetterSelector || !$(resetterSelector)) {
      return;
    }

    let slider = el.data("ionRangeSlider");
    let resetFrom = el.data('fromresetter');
    // let initialOptionsSlider = slider.options;

    $(resetterSelector).change(function() {
      let resetterEl = $(this);

      if (resetterEl.prop('checked')) {
        slider.update({
          from: 0,
        });
      } else {
        slider.update({
          from: resetFrom,
        });
      }

    });

  });

  let validateKoopHuurMessageShown = false;
  function validateKoopHuur() {
    // console.log(slidertehuur.data("ionRangeSlider").result.from);
   if (!validateKoopHuurMessageShown && slidertehuur.data("ionRangeSlider").result.from == 0 && slidertekoop.data("ionRangeSlider").result.from == 0 )  {
     alert('U kunt niet zowel het budget voor koop als het budget voor huur voor het pand op 0 zetten. Een pand is tenslotte altijd te koop of te huur, nooit gratis. Als u het pand alleen wilt huren, kies dan via de slider uw budget voor huur en zet het budget koop pand op 0. Als u alleen het pand wilt kopen, kies dan via de slider uw budget voor koop pand en zet budget huur op 0. Als u zowel openstaat voor koop of huur van het pand, kiest u in beide sliders het door u gewenste budget.');
     validateKoopHuurMessageShown = true;
   }
  }

  checktehuur.change(function() {
    if (this.checked) {
      $('.js-checktekoop').prop('checked', false);
    }
  });

  checktekoop.change(function() {
    if (this.checked) {
      $('.js-checktehuur').prop('checked', false);
    }
  });


  $('[data-toggle="tooltip"]').tooltip();

  $('.carousel').carousel();
  addQblCarouselEvents(document);

  $('.goTop').on('click', function(e){
    $("html, body").animate({scrollTop: $("body").offset().top}, 500);
    return false;
  });

  let header = document.querySelector(".js-main-header");
  let headroom  = new Headroom(header, {
    "tolerance": 10,
  });
  headroom.init();

  $('body.horeca').addClass('loaded');

  $('.js-accordion-body').hide();
  $('.js-accordion-head').find('.fa-caret-down').addClass('rotate-right');

  $('.js-accordion-head').click(function() {
    let body = $(this).next('.js-accordion-body');

    if (body.is(':visible')) {
      body.slideUp();
      $(this).find('.fa-caret-down').addClass('rotate-right');
    } else {
      // $('.js-accordion-head').find('.fa-caret-down').addClass('rotate-right');
      $(this).find('.fa-caret-down').removeClass('rotate-right');
      // $('.js-accordion-body').slideUp();
      body.slideDown();
    }
  });

  fix_list_bubble();

  $('.js-countdown').each(function() {
    let $this = $(this),
        finalDate = $this.data('countdown'),
        design = $this.data('countdown-design');

    if (design == 'fancy') {
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime(''
          + '<div><span>Dagen</span><span>%D</span></div>'
          + '<div><span>Uren</span><span>%H</span></div>'
          + '<div><span>Minuten</span><span>%M</span></div>'
          + '<div><span>Seconden</span><span>%S</span></div>')
        );
      });
    } else {
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime('%-D %!D:dag,dagen; en %H:%M:%S')
        );
      });
    }

    if($(this)[0].hasAttribute('data-countdown-finish')) {
      $this.on('finish.countdown', function() {
        $('[data-countdown-showonfinish]').collapse('show');
      });
    }
  });
});

window.addQblCarouselEvents = function(carouselContainer) {
  // Click on carousel will follow card link
  let objectItems = Array.from(carouselContainer.querySelectorAll(".object-item"));
  objectItems.forEach(objectItem => {
    let carouselInner = objectItem.querySelector(".carousel-inner");
    if (carouselInner === null) return;
    carouselInner.addEventListener("click", event => {
      let link = objectItem.querySelector(".stretched-link");

      if (link !== null) {
        link.target = event.ctrlKey || event.metaKey ? "_blank" : "_self";
        link.click();
      }
    })
  });
}


function fix_list_bubble()
{
  let detailsList = document.querySelectorAll(".details_list");
  let wordCount = 3;

  if (window.matchMedia("(orientation: portrait)").matches)
  {
    wordCount = 1;
  }

  detailsList.forEach(list => {
    let dropdownContainer = list.parentElement.querySelector(".dropdown");
    let dropdownDropdown = dropdownContainer.querySelector(".dropdown-menu");
    let dropdownBubble = dropdownContainer.querySelector(".js-details-btn");

    let in_words = list.innerText.split(",");
    let out_words = [];

    for (let i in in_words)
    {
      let word = in_words[i].trim();

      if (i >= wordCount)
      {
        let elem = document.createElement("span");
        elem.classList.add("dropdown-item");
        elem.classList.add("disabled");

        elem.innerText = word;

        dropdownDropdown.appendChild(elem);
      }
      else
      {
        out_words.push(word);
      }
    }

    dropdownBubble.innerText =  `+${(in_words.length - out_words.length).toString()}`;
    if (dropdownBubble.innerText.length > 0) dropdownContainer.classList.remove("d-none");
    list.innerText = out_words.join(", ");
  });
}

var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});

$(function () {
  $('#ebookModal').on('hide.bs.modal', function () {
    let ebook_article_id = $(this).find('[name="ebook_article_id"]').val();

    $.ajax({
      type: 'POST',
      data: {
        action_name: 'close_ebook',
        ebook_article_id: parseInt(ebook_article_id),
      },
    });
  });
});


$(function () {
  const Uppy = require('@uppy/core')
  const Dashboard = require('@uppy/dashboard')
  const Webcam = require('@uppy/webcam')
  const Tus = require('@uppy/tus')
  const DropTarget = require('@uppy/drop-target')
  const UppyForm = require('@uppy/form')
  const Dutch = require('@uppy/locales/lib/nl_NL')

  Dutch.strings.done = 'Verwijder en begin opnieuw';

  $('.js-form-with-uppy').each(function(){

    let dashboardForm = this;
    let dashboardEl = $(this).find('.uppyDashboardContainer').first();

    if (!dashboardEl.length) {
      return;
    }

    const uppy = new Uppy({
      debug: false,
      locale: Dutch,
      autoProceed: true,
      allowMultipleUploadBatches: true,
      restrictions: {
        maxFileSize: 20000000,
        maxNumberOfFiles: 2,
        minNumberOfFiles: 1,
        allowedFileTypes: ['image/*', '.pdf'],
        requiredMetaFields: [],
      }
    })
    .use(Dashboard, {
      // trigger: '.UppyModalOpenerBtn',
      inline: true,
      target: dashboardEl.get(0),
      showProgressDetails: true,
      note: 'Afbeeldingen en PDF, max 2 bestanden, tot 20 MB',
      height: 300,
      metaFields: [
        { id: 'name', name: 'Name', placeholder: 'bestandsnaam' },
        { id: 'caption', name: 'Caption', placeholder: 'beschrijven waar de afbeelding over gaat' }
      ],
      browserBackButtonClose: false,
      doneButtonHandler: () => {
        uppy.reset();
        $(dashboardForm).find('input[name="uppyResult"]').val('');
      }
    })
    .use(Webcam, { target: Dashboard })
    .use(Tus, { endpoint: '/files/' })
    .use(DropTarget, {target: document.body })
    .use(UppyForm, {
      target: dashboardForm,
      resultName: 'uppyResult',
      getMetaFromForm: false,
      addResultToForm: true,
      submitOnSuccess: false,
      triggerUploadOnSubmit: false
    })
    // .use(StatusBar, {
    //   id: 'StatusBar',
    //   target: 'body',
    //   hideAfterFinish: true,
    //   showProgressDetails: false,
    //   hideUploadButton: false,
    //   hideRetryButton: false,
    //   hidePauseResumeButton: false,
    //   hideCancelButton: false,
    //   doneButtonHandler: null,
    //   locale: {done: 'blaat'},
    // })

    uppy.on('upload-success', (file, response) => {
      // console.log(file);
      // console.log(response);
      // console.log(file.name, response.uploadURL)
      // const img = new Image()
      // img.width = 300
      // img.alt = file.id
      // img.src = response.uploadURL
      // document.body.appendChild(img)
    })
  });
  // uppy.on('complete', result => {
  //   console.log('Succesvolle bestanden:', result.successful)
  //   console.log('Mislukte bestanden:', result.failed)
  // })
});


$(function () {

  // Used in bieding form
  $('.js-disable-other-fields').each(function(index){


    let selectEl = this;
    let $selectEl = $(this);

    if (selectEl.nodeName === 'DIV') {
      return;
    }

    let selectTriggerText = selectEl.dataset.optionTriggerText;
    if (!selectTriggerText) {
      selectTriggerText = '1';
    }

    let selectDisableSelector = selectEl.dataset.disableFieldsSelector;

    if (!selectDisableSelector) {
      console.log('No selectDisableSelector found for:', selectEl);
      return;
    }

    $selectEl.on('change', function(){
      let optionEl = this;
      let $optionEl = $(this);
      let optionText = '';

      // INPUT
      if (selectEl.nodeName === 'INPUT') {
        if ($selectEl.attr('type') === 'checkbox') {
          optionText = String(optionEl.checked ? optionEl.checked : '');

          if (optionText) {
            selectTriggerText = optionText;
          }
        } else {
          optionText = optionEl.attr('value');
        }

      }
      // SELECT
      else if (selectEl.nodeName === 'SELECT') {
        optionText = optionEl.options[optionEl.selectedIndex].text;
      }

      $(selectDisableSelector).each(function(){
        let disableSelect = this;
        let $disableSelect = $(this);

        if (optionText.toLowerCase().match(selectTriggerText.toLowerCase())) {

          $disableSelect.attr('disabled', true);

          // Set previous selected index once
          if (!disableSelect._previousSelectedIndex) {
            disableSelect._previousSelectedIndex = $disableSelect.prop('selectedIndex');
          }

         // SELECT
         if (disableSelect.nodeName === 'SELECT') {
            $disableSelect.prepend($('<option>', {
                value: '',
                text: 'Niet van toepassing'
            }));

            $disableSelect.prop('selectedIndex',0);
         }


        } else {
          if (disableSelect.disabled) {
            $disableSelect.removeAttr('disabled');
            $disableSelect.find('option[value=""]').first().remove();

            let newIndex = 0;
            if (disableSelect._previousSelectedIndex > 0) {
              newIndex = disableSelect._previousSelectedIndex;
            }

            $disableSelect.prop('selectedIndex',newIndex);
          }
        }

        if ($disableSelect.hasClass('js-select')) {
          $disableSelect.selectpicker('refresh');
        }

      });

    });

    $selectEl.trigger('change');

    // else if (selectEl.nodeName === 'INPUT' && $(selectEl).attr('type') === 'checkbox') {
    //   console.log('CHECKBOX');
    // }

  });

});
